import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./tabsForRouting.scss";
import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const TabsForRouting = (props) => {
  const [selectedTab, setselectedTab] = useState("");
  const [programNameState, setprogramNameState] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipOpen2, settooltipOpen2] = useState(false);
  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  if (props.programNameState.programName !== programNameState) {
    const { programNameState } = props;
    setprogramNameState(programNameState.programName);
  }
  console.log("Porgram", programNameState);
  const { pathname } = props.location;
  const { status } = props;
  return (
    <div className="TabsForRouting">
      <Modal isOpen={modal} toggle={toggleModal} centered={true} size={"md"}>
        <ModalHeader toggle={toggleModal}>Oops! You made a mistake</ModalHeader>
        <ModalBody>You forgot to select a class (from the gray panel)</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleModal}>
            Got it!
          </Button>
        </ModalFooter>
      </Modal>
      <h5 className="plannerHeading">
        {typeof programNameState !== "undefined"
          ? programNameState
          : "First select Program from the left panel"}
      </h5>
      <fieldset className="field">
        {status === 6 ? (
          <>
            <Link
              to={
               "/TeacherDashboard/home"
              }
            >
              <button
                className={
                  pathname === "/TeacherDashboard/home"
                    ? "btnForRouteSelected"
                    : "btnForRoute"
                }
              >
                Home
              </button>
            </Link>
            <Link
              to={
                typeof programNameState === "undefined"
                  ? "/TeacherDashboard"
                  : "/TeacherDashboard/ClassStart3"
              }
            >
              <button
                className={
                  pathname === "/TeacherDashboard/ClassStart3"
                    ? "btnForRouteSelected"
                    : "btnForRoute"
                }
                onClick={() => {
                  if (typeof programNameState === "undefined") setModal(true);
                }}
              >
                Start Class
              </button>
            </Link>
            <Link
              to={
                typeof programNameState === "undefined"
                  ? "/TeacherDashboard"
                  : "/TeacherDashboard/Planner"
              }
            >
              <button
                className={
                  pathname === "/TeacherDashboard/Planner" ? "btnForRouteSelected" : "btnForRoute"
                }
                onClick={() => {
                  if (typeof programNameState === "undefined") setModal(true);
                  else setselectedTab("Planner");
                }}
              >
                Create Planner
              </button>
            </Link>
            {/* <Link
              to={
                typeof programNameState === "undefined"
                  ? "/TeacherDashboard"
                  : "/TeacherDashboard/UploadHomework"
              }
            >
              <button
                className={
                  pathname === "/TeacherDashboard/UploadHomework"
                    ? "btnForRouteSelected"
                    : "btnForRoute"
                }
                onClick={() => {
                  if (typeof programNameState === "undefined") setModal(true);
                  else setselectedTab("Planner");
                }}
              >
                Upload Image/Video
              </button>
            </Link> */}
            <Link to={"/TeacherDashboard/MyAvailability"}>
              <button
                className={
                  pathname === "/TeacherDashboard/MyAvailability"
                    ? "btnForRouteSelected"
                    : "btnForRoute"
                }
              >
                My Availability
              </button>
            </Link>
          </>
        ) : 
          <Link to={"/TeacherDashboard/RecruitmentTab"}>
            <button
              className={
                pathname === "/TeacherDashboard/RecruitmentTab"
                  ? "btnForRouteSelected"
                  : "btnForRoute"
              }
            >
              Recruitment Process
            </button>
          </Link>
        }
      </fieldset>
      {/* <hr /> */}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
  };
}
export default withRouter(connect(mapStateToProps, null)(TabsForRouting));
